module.exports = "/packs/images/forms/form-success~8577ddfc2f999134864676e518823572.png";